<button celum-button data-test-language-chooser mat-button class="language-chooser_button" [disableRipple]="true" [matMenuTriggerFor]="menu">
  {{ 'LANGUAGE_PICKER.LANGUAGES' | translate }} ({{ activeLanguages()?.size }})
  <celum-icon [configuration]="arrowIcon"></celum-icon>
</button>
<mat-menu #menu="matMenu" class="language-chooser_menu">
  <button mat-menu-item class="language-chooser_menu-item" (click)="handleClick($event)">
    <celum-checkbox-item
      class="language-chooser_menu-checkbox"
      [attr.data-test-default-language]="defaultLanguage()"
      [checked]="true"
      [disabled]="true"
      [hoverEnabled]="false"
      [text]="'LANGUAGE.' + defaultLanguage() | uppercase"
      [orientation]="'row'"
      [showToolTip]="false"></celum-checkbox-item>
  </button>
  @for (lang of availableLanguages(); track lang) {
    @if (defaultLanguage() !== lang) {
      <button mat-menu-item class="language-chooser_menu-item" (click)="handleClick($event)">
        <celum-checkbox-item
          class="language-chooser_menu-checkbox"
          [checked]="activeLanguages().has(lang)"
          [attr.data-test-language]="lang"
          [hoverEnabled]="false"
          [orientation]="'row'"
          [text]="'LANGUAGE.' + lang | uppercase"
          [showToolTip]="false"
          (selectionChanged)="languageWasChecked($event.checked, lang)"></celum-checkbox-item>
      </button>
    }
  }
</mat-menu>
